import * as React from 'react';

import { type ColorSchemePreference, getInitialColorTheme, getThemeFromUrl, setColorSchemePreference } from '../utils';

const ColorThemeContext = React.createContext<{
  colorTheme: string;
  onColorThemeChange: (colorTheme: string) => void;
}>({
  colorTheme: 'light',
  onColorThemeChange: () => {},
});

export const useColorTheme = () => {
  return React.useContext(ColorThemeContext);
};

const SyncHtmlAtribute = () => {
  const { colorTheme } = useColorTheme();
  React.useEffect(() => {
    document.documentElement.setAttribute('data-color-theme', colorTheme);
  }, [colorTheme]);
  return null;
};

export const ColorThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [colorTheme, setColorTheme] = React.useState<string>(getInitialColorTheme);

  React.useEffect(() => {
    const themeFromUrl = getThemeFromUrl();
    if (themeFromUrl) {
      setColorSchemePreference(themeFromUrl as ColorSchemePreference);
    }
  }, []);

  return (
    <ColorThemeContext.Provider value={{ colorTheme, onColorThemeChange: setColorTheme }}>
      <SyncHtmlAtribute />
      {children}
    </ColorThemeContext.Provider>
  );
};
